<template>
    <div id="area-personal">
        <Header></Header>
            <router-view></router-view>
        <Footer></Footer>
    </div>
</template>

<script>

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
    name: 'app',
    components: {
    Header,
    Footer
  }
};
</script>
<style lang="scss">

  $fontdir: "../core/core-framework/assets/";
  $baseimgdir: "../core/core-framework/assets/img";
  $font-family-sans-serif: RisingSun, sans-serif;
  
  
  @import './core/core-framework/assets/scss/inc/reduced_bootstrap';
  
  main .container {
    padding-left: 16px;
    padding-right: 16px;
    
  }
  .container {
    @media screen and (min-width: 1349px) { max-width: 1216px; }
    @media screen and (min-width: 1500px) { max-width: 1664px; }
  }

  html, body {
    height: 100%;
    width: 100%;
  }

  #area-personal {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  }


</style>
